import { render, staticRenderFns } from "./block-templates-card-upload.vue?vue&type=template&id=045e0bf3&scoped=true&lang=pug"
import script from "./block-templates-card-upload.vue?vue&type=script&lang=js"
export * from "./block-templates-card-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e0bf3",
  null
  
)

export default component.exports